import React, { ReactElement, useMemo } from 'react';

import { Grid } from '@mui/material';
// import { Panel, PanelContent } from '@apigrowfinance/pbolt-panel';
import { useParams } from 'react-router-dom';

// import LoadingError from '@components/loadingError/LoadingError';
import DelinquencyPanel from '@components/overviewPanels/delinquencyPanel/DelinquencyPanel';
import OverviewItem from '@components/overviewPanels/OverviewItem';
import { useAccount } from '@contexts/AccountProvider';
import { ProgramParameters } from '@enums/programs/programParameters';
import useGetDelinquency from '@hooks/queries/useGetDelinquency';

export type DelinquencyPanelContainerProps = {
    children: ReactElement;
};

const DelinquencyPanelContainer = ({
    children,
}: DelinquencyPanelContainerProps) => {
    const { accountId } = useParams();
    const {
        program,
        programHasParameter,
        isLoading: isLoadingAccount,
    } = useAccount();
    const currencyCode = program?.currency_numeric_code;

    const isDelinquencyEnabled = useMemo(
        () => programHasParameter(ProgramParameters.DELINQUENCY),
        [programHasParameter],
    );

    const {
        data: delinquency,
        isLoading: isLoadingDelinquency,
        isError,
    } = useGetDelinquency({
        accountId: +accountId,
        enabled: isDelinquencyEnabled,
    });

    const isLoading = isLoadingAccount || isLoadingDelinquency;
    const totalOverDue = delinquency?.[0]?.calculation_memory?.overdue_amount;
    const showDelinquencyPanel =
        isDelinquencyEnabled && !isError && totalOverDue > 0;
    return (
        <Grid container spacing={2}>
            {showDelinquencyPanel && (
                <Grid item xs={12} md={6}>
                    <DelinquencyPanel
                        accountId={accountId}
                        totalOverDue={totalOverDue}
                        isLoading={isLoading}
                        currencyCode={currencyCode}
                    />
                </Grid>
            )}
            {/* TODO: Temporarily disabled due to Delinquency API requiring the vpn*/}
            {/*{isError && (*/}
            {/*    <Grid item xs={12} md={6}>*/}
            {/*        <Panel>*/}
            {/*            <PanelContent>*/}
            {/*                <Box*/}
            {/*                    sx={{*/}
            {/*                        display: 'flex',*/}
            {/*                        justifyContent: 'center',*/}
            {/*                        alignItems: 'center',*/}
            {/*                        width: '100%',*/}
            {/*                        height: '100%',*/}
            {/*                    }}>*/}
            {/*                    <LoadingError />*/}
            {/*                </Box>*/}
            {/*            </PanelContent>*/}
            {/*        </Panel>*/}
            {/*    </Grid>*/}
            {/*)}*/}
            <Grid
                item
                xs={12}
                md={isDelinquencyEnabled && totalOverDue ? 6 : 12}
                // md={(isDelinquencyEnabled && totalOverDue) || isError ? 6 : 12}
                data-testid="child-panel">
                <OverviewItem
                    name="CardLinkPanel"
                    component={children}
                    grid={{ xs: 12 }}
                />
            </Grid>
        </Grid>
    );
};

export default DelinquencyPanelContainer;
